// ----------------------------------------------------------------------
// The token a password reset link carries, taken out of the address bar at
// once, as an invitation link's is (`invitationLinkToken`).
//
// The link is `/login/reset#t=<token>`. The fragment never reaches a server
// or a `Referer`, but it is in `location.href`, which PostHog and Sentry both
// record once they start. This runs at the top of `index`, before either, and
// moves the token into this tab's storage.
// ----------------------------------------------------------------------

const KEY = 'beast.passwordReset.token'

export const RESET_PATH = '/login/reset'

/** Moves a link's token from the address bar into this tab. Runs at boot. */
export const resetLinkTokenCapture = (
  location: Pick<Location, 'pathname' | 'search' | 'hash'> = window.location,
  history: Pick<History, 'replaceState' | 'state'> = window.history,
  storage: Storage = sessionStorage,
): void => {
  if (location.pathname !== RESET_PATH) {
    return
  }

  const token = /(?:^#|&)t=([A-Za-z0-9_-]+)/.exec(location.hash)?.[1]
  if (!token) {
    return
  }

  storage.setItem(KEY, token)
  history.replaceState(
    history.state,
    '',
    `${location.pathname}${location.search}`,
  )
}

export const resetLinkTokenRead = (
  storage: Storage = sessionStorage,
): string | null => storage.getItem(KEY)

/** Once the reset has been used, so a reload does not offer the form again. */
export const resetLinkTokenForget = (
  storage: Storage = sessionStorage,
): void => {
  storage.removeItem(KEY)
}
